import { gql } from 'graphql-tag';

export const deleteAlarmLimit = gql`
  mutation deleteAlarmLimit($id: String) {
    deleteAlarmLimit(id: $id)
  }
`;
